module.exports = __webpack_public_path__ + "img/banner-main.89ba5665.png";